<!--<section class="banner">-->
<!--    <div class="container-fluid bg-sea-green mt-5">-->
<!--        <div class="container mt-5 pt-5">-->
<!--            <div class="row g-5">-->
<!--                <div class="col-md-6 d-flex text-center text-md-start align-items-center">-->
<!--                    <div>-->
<!--                        <h1 class="fw-bolder font-56"><span-->
<!--                            class="brand-primary-text-color">Comprehensive Cloud & DevOps Solutions </span>-->
<!--                            by Volmint Technologies</h1>-->
<!--                        <p class="my-4 fs-6 text-secondary text-wrap f-20 justify-text">At Volmint Technologies, we-->
<!--                            offer comprehensive Cloud & DevOps solutions that cover every aspect of server management.-->
<!--                            Our services include Managed Cloud Services, DevOps, and Containers, ensuring seamless-->
<!--                            scalability, automation, and efficiency for your infrastructure. With our expert team, we-->
<!--                            help businesses streamline operations, reduce costs, and accelerate deployment through-->
<!--                            state-of-the-art technologies. Whether you are looking to optimize your cloud environment or-->
<!--                            automate your workflows, Volmint Technologies provides the tools and expertise to drive-->
<!--                            success in today's digital landscape.-->
<!--                        </p>-->
<!--                        <button class="btn bg-white px-5 rounded-0 border-0 shadow-lg fw-bold hover-effect"-->
<!--                                (click)="openModal()">View Demo <i-->
<!--                            class="ms-3 fa-solid fa-arrow-right"></i>-->
<!--                        </button>-->
<!--                        <ng-template #contactFormModal>-->
<!--                            <app-contact-form [isModalOpen]="isModalOpen"-->
<!--                                              (closeModal)="closeModal()"></app-contact-form>-->
<!--                        </ng-template>-->
<!--                        <div *ngIf="isModalOpen" class="modal-overlay" (click)="handleOverlayClick($event)">-->
<!--                            <ng-container *ngTemplateOutlet="contactFormModal"></ng-container>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="col-md-6 d-flex justify-content-end py-5 d-flex justify-content-center">-->
<!--                    <div-->
<!--                        class="card banner-bg-color md:mr-0 position-relative h-100 w-100 border-0 shadow-lg d-flex justify-content-center border-radius-10">-->
<!--                        <img src="assets/img/landing-new/server-management/introduction-website-development.jpg"-->
<!--                             alt="Image"-->
<!--                             class="img-fluid border-radius-10"/>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
<!--</section>-->
<section class="section_hero h-100">
    <div class="container-fluid mt-6 pb-5">
        <div class=" ">
        </div>
        <div class="container  mt-5 pt-5">
            <div class="row g-5">
                <div class="col-md-6 d-flex text-center text-md-start align-items-center">
                    <div>
                        <h1 class="fw-bolder text-white font-56">Smarter and Faster - Achieve 3X Results With Our Cloud
                            and DevOps Services</h1>
                        <p class="my-4 fs-6 text-white text-wrap f-20 justify-text">Explore the power of the cloud,
                            streamline your design, development, and operations processes with Volmint Technologies. Our
                            Cloud and DevOps services help your business deploy faster, build smarter, and stay ahead in
                            the digital era.

                        </p>
                        <button type="submit"
                                class="bg-white border-0 text-color px-5 py-2 fs-6 mt-4 fw-bold hover-effect"
                                (click)="openModal()">View Demo <i
                            class="ms-3 fa-solid fa-arrow-right"></i>
                        </button>
                        <ng-template #contactFormModal>
                            <app-contact-form [isModalOpen]="isModalOpen"
                                              (closeModal)="closeModal()"></app-contact-form>
                        </ng-template>
                        <div *ngIf="isModalOpen" class="modal-overlay" (click)="handleOverlayClick($event)">
                            <ng-container *ngTemplateOutlet="contactFormModal"></ng-container>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 d-flex justify-content-end py-5 d-flex justify-content-center">
                    <div
                        class="  md:mr-0 position-relative  border-0 d-flex justify-content-center border-radius-10">
                        <img src="assets/img/landing-new/server-management/Smarter and Faster -Achieve 3X Results With Our Cloud and DevOps Services.jpg" alt="Image"
                             class="img-fluid border-radius-10 "/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<div class="container-fluid " style="background: #F1F5FA">
    <div class="container py-5">
        <div class="row animate-on-scroll">

            <div class="col-md-6 ps-md-5 py-md-5 py-4">
                <span class="text-color fw-bold">About -</span>
                <h2 class=" fs-2 fw-bolder "> Volmint’s Cloud and DevOps Services - Transforming Business</h2>

            </div>
            <div class="col-md-6 m-0 p-0 text-right">
                <p class="text-secondary  text-wrap justify-text">Following the digital landscape, scalability and agility are
                    among the foremost challenges product companies face nowadays. Cloud delivery can be a simple yet
                    challenging process. Volmint Technologies, a renowned IT company in India, takes pride in offering
                    the best cloud and DevOps consulting services. We blend the flexibility of cloud computing with the
                    efficiency of DevOps practices to supercharge your business operations.</p>
                <p class=" text-secondary text-wrap justify-text">By bringing business, operations, and development expertise
                    together, we provide a fully automated DevOps environment. Regardless of your business's unique
                    goals and approach, our services can be customized. From managed cloud solutions to container
                    orchestration, that too, with affordable cost is not that easy but we make it possible. We ensure
                    your IT infrastructure is always ready to deliver exceptional performance, whether you are looking
                    to optimize your cloud environment or automate your workflows.
                </p>
            </div>
        </div>
    </div>
    <div class=" container mx-auto px-6 pb-5">
        <h2 class="text-color fw-bold  text-center  mb-3">Delivering High-Performance Cloud and DevOps Solutions – Our
            Services</h2>

        <div class="row  px-2 hero-banner shadow py-4 position-relative">
            <img src="assets/img/landing-new/server-management/db.png" class="position-absolute w-25 opacity-25"  alt="" style="left: 75%; top: -5%; z-index: -1"/>
            <div class="col-md-3 d-flex flex-column mb-4  ">
                <div class="nav mt-50px flex-column " id="v-tabs" role="tablist" aria-orientation="vertical">
                    <button
                        class="nav-link btn border text-color fw-semibold text-start my-2"
                        [class.active]="activeTab === 'cloud'"
                        (click)="activeTab = 'cloud'"
                        id="cloud-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#cloud"
                        type="button"
                        role="tab"
                    >
                        Cloud Management Services
                    </button>

                    <button
                        class="nav-link btn border  text-color fw-semibold text-start my-2"
                        [class.active]="activeTab === 'devops'"
                        (click)="activeTab = 'devops'"
                        id="devops-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#devops"
                        type="button"
                        role="tab"
                    >
                        DevOps Consulting Services
                    </button>

                    <button
                        class="nav-link btn border text-color fw-semibold text-start my-2"
                        [class.active]="activeTab === 'containers'"
                        (click)="activeTab = 'containers'"
                        id="containers-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#containers"
                        type="button"
                        role="tab"
                    >
                        Containers
                    </button>

                </div>
                <div class="align-self-end overflow-hidden h-100">
                    <img src="assets/img/landing-new/server-management/Cloud management services.png" alt="" style="margin-bottom: -709px">
                </div>
            </div>

            <div class="col-md-9 border-2 border-start">
                <div class="tab-content p-4" id="v-tabsContent">

                    <!-- Cloud Management Services -->
                    <div class="tab-pane fade show active" id="cloud" role="tabpanel">
                        <h3 class="fw-bold mb-3 text-color ">Cloud Management Services</h3>
                        <p class="mb-6 text-secondary">Volmint Technology, the leading cloud managed services providers, offers
                            end-to-end support for your cloud infrastructure to maximize efficiency and security. We
                            ensure seamless, secure, scalable, and cost-effective operations from initial migration to
                            ongoing optimization. Our team of experts handles the complexities of cloud infrastructure,
                            monitoring, and maintenance so that you can focus on your business growth and goals. </p>
                        <h4 class="fw-semibold text-color mb-4">Robust Managed Cloud Services for Seamless
                            Operations</h4>
                        <ol class="list-decimal ">
                            <li><p class="text-secondary"><strong>Architecting & Designing - </strong> Our first approach is to custom
                                architect and design a cloud environment that is both scalable and secure. We craft
                                solutions that are aligned with your unique business objectives, ensuring a solid
                                foundation for the cloud strategy.</p></li>
                            <li><p class="text-secondary"><strong>Disaster Recovery and Backups -</strong> We aim to protect critical data and
                                applications from unauthorized practices. Thus, we implement comprehensive DR (Disaster
                                Recovery) and backup solutions to recover your data quickly in the event of system
                                failure, natural disaster, or cyberattack.</p></li>
                            <li><p class="text-secondary"><strong> Cloud Assessment -</strong> Our cloud assessment services analyze the IT
                                environment thoroughly, including performance, cost, security, and scalability to build
                                a roadmap that aligns with the business goals. Whether you are looking to optimize an
                                existing infrastructure or are new to the cloud, we ensure a good cloud investment.</p>
                            </li>
                            <li><p class="text-secondary"><strong>Integration -</strong>We enable seamless cloud integration by connecting
                                cloud-based services and applications with your ongoing IT infrastructure. Our
                                integration solutions facilitate smooth data exchange and communication between
                                different platforms to improve workflow and efficiency.</p></li>
                            <li><p class="text-secondary"><strong>Administration — </strong> Through our cloud administration services, we
                                manage, monitor, and optimize your current cloud infrastructure. From configuring cloud
                                resources to managing user access, performance tuning, and system updates, we handle
                                everything to ensure smooth operations.</p></li>
                            <li><p class="text-secondary"><strong>Advanced Cloud Security -</strong> We implement robust cloud security
                                measures to protect your data and application from forbidden access, breaches, and other
                                threats. Additionally, the service includes regular compliance checks, threat detection,
                                and encryption. </p></li>
                            <li><p class="text-secondary"><strong>Scalable Cloud Storage -</strong>Our high-availability infrastructure
                                guarantees optimal uptime, keeping your business operating. With versatile and effective
                                alternatives, you can easily scale your storage solutions as your organization expands,
                                making sure you only pay for what you need.</p></li>
                        </ol>
                    </div>

                    <!-- DevOps Consulting Services -->
                    <div class="tab-pane fade" id="devops" role="tabpanel">
                        <h3 class="fw-bold mb-3 text-color ">DevOps Consulting Services</h3>
                        <p class="mb-6 text-secondary">Development and Operations services accelerating seamless automation. We have
                            designed DevOps services to transform the way your teams develop, deliver, and maintain
                            applications. Our services streamline workflow, increase collaboration and efficiency. From
                            continuous integration (CI) and continuous delivery (CD) pipelines to automated testing and
                            infrastructure as code (IaC), we ensure faster, reliable, and scalable IT
                            infrastructure.</p>
                               <h4 class="fw-semibold text-color mb-4">Accelerate Development Cycles & Enhance Collaboration
                            with Our DevOps Consulting Services</h4>
                        <ol class="list-decimal ">
                            <li><p class="text-secondary"><strong>Assessment and Planning - </strong> The first move is to understand the business goals and design a robust DevOps architecture accordingly. We focus on streamlining processes, enhancing collaboration, and facilitating continued delivery.</p></li>
                            <li><p class="text-secondary"><strong>Extended Orchestration -</strong> Our extended orchestration services can automate and simplify the software development lifecycle. We follow several techniques to offer seamless collaboration among the development, testing, and deployment teams.</p></li>
                            <li><p class="text-secondary"><strong> Continuous Integration (CI) -</strong> Our CI services encourage developers to combine their code changes regularly into a shared repository. The process ensures that the changes are tested automatically and helps teams identify and resolve issues quickly.</p>
                            </li>
                            <li><p class="text-secondary"><strong>Continuous Deployment (CD)- </strong> Continuous deployment services help teams respond in real time and ensure incredible efficiency for businesses. It allows for the rapid delivery of new features, enhancing responsiveness to market demands.</p></li>
                            <li><p class="text-secondary"><strong>	SAST Integration — </strong> TWe integrate Static Application Security Testing (SAST), a frequently used application security tool that helps to identify an application’s source, byte, or binary code. The SAST service allows us to scan the root cause of vulnerabilities in your code and treat them.</p></li>
                            <li><p class="text-secondary"><strong>Pipeline Integration -</strong> We offer Pipeline Integration services that allow a seamless transaction among the stages during an application design, development, delivery, and deployment. It enhances the workflow of CI/CD by integrating several platforms into a cohesive pipeline.</p></li>
                            <li><p class="text-secondary"><strong>Validation-</strong> Validation service is crucial for ensuring that the application meets predefined quality and performance standards before reaching final production. Implementing automated testing strategies and validating your software at each stage of the development lifecycle.</p></li>
                        </ol>
                    </div>

                    <!-- Containers -->
                    <div class="tab-pane fade" id="containers" role="tabpanel">
                       <h3 class="fw-bold mb-3 text-color ">Containers</h3>
                        <p class="mb-6 text-secondary">Containers play a pivotal role in enabling the applications to run consistently across different environments, ensuring absolute deployment and reduced compatibility issues. Our Container as a Service (CaaS) manages, builds, and scales applications with unmatched flexibility and efficiency. We leverage industry-leading tools and adopt containerized solutions, improve agility, reduce cost, and accelerate time-to-market, all while maintaining secure, stable, and predictable deployments.</p>
                              <h4 class="fw-semibold mb-4 text-color">Comprehensive Container Services for Scalable Application Management</h4>
                        <ol class="list-decimal ">
                            <li><p class="text-secondary"><strong>Container Orchestration - </strong> Container Orchestration service, evaluates and optimizes your existing or newly launched applications, suggesting recommendations and automating workflow that aligns with industry best practices. We use Kubernetes, Docker, OpenShift, and AWS Elastic Container.</p></li>
                            <li><p class="text-secondary"><strong>Container Security -</strong> Protect your applications with advanced security measures, including real-time vulnerability assessments, runtime threat detection, and compliance management. We deliver peace of mind with secure and reliable containerized ecosystems.</p></li>
                            <li><p class="text-secondary"><strong> Containerization of Applications -</strong> The containerization of application services helps to increase the speed of the operating system, develop faster, and maintain the spread of bugs. Experienced enhanced performance and effortless deployment across diverse environments.
                            </p>
                            </li>
                            <li><p class="text-secondary"><strong>Microservices Architecture Support - </strong>
                                Simplify and automate the building, development, integration, and testing process of software with Microservices Architecture Support. The service leads developers to find issues and bottlenecks, enabling your business to innovate at scale.
                            </p></li>
                            <li><p class="text-secondary"><strong>Multi-Cloud & Hybrid Deployment — </strong>
                                Multi-cloud & Hybrid Development services improve reliability and redundancy, make easier to move away from single-vendor. It ensures more ownership of companies over the IT infrastructure and deploys workloads across platforms.
                            </p></li>
                            <li><p class="text-secondary"><strong>CI/CD Integration with Container -</strong> CI/CD integration services bundle an application’s source code, dependencies, libraries, and runtime into a single package. Accelerate your software delivery with integrated CI/CD pipelines. </p></li>
                            <li><p class="text-secondary"><strong>Disaster Recovery & Backup for Containers -</strong> DR and Backup for containers is a process of restoring applications and data after a disaster or failure. Ensure business continuity with automated backup and disaster recovery plans during unforeseen challenges.</p></li>
                        </ol>
                    </div>

                </div>
            </div>
        </div>

    </div>
</div>
<section class=" container-fluid section_hero">
    <div class="container mx-auto px-6">
        <h2 class="text-white fw-bold text-center mb-12">
            Our Process for Cloud and DevOps Services
        </h2>

        <div class="row g-4">
            <div class="col-md-6">
                <div class="bg-white p-4 h-100 shadow-sm border-0">
                    <div class="card-body">
                        <div class="d-flex align-items-center">
                            <i class="fa-solid text-color fa-magnifying-glass-chart  fs-1  me-3"></i>
                            <h3 class="card-title text-color fs-5 fw-bold my-3">
                                Consultation & Assessment
                            </h3>
                        </div>

                        <p class="card-text text-secondary">
                            We analyze your ongoing IT infrastructure, identify challenges in maintaining the application, and align with your goals to conceptualize your product. We also help ideate new products from scratch and design custom solutions.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Step 2 -->
            <div class="col-md-6">
                <div class="bg-white p-4 h-100 shadow-sm border-0">
                    <div class="card-body">
                        <div class="d-flex align-items-center">

                        <i class="fa-solid text-color fa-lightbulb  fs-1 me-3"></i>

                        <h3 class="text-color my-3 fs-5 fw-bold">
                             Strategy Development
                        </h3>
                        </div>
                        <p class="card-text text-secondary">
                            We create a tailored roadmap for managed cloud services, DevOps implementations, and containerization based on your business needs. Our experts design wireframes to help you find the perfect product-market fit.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Step 3 -->
            <div class="col-md-6">
                <div class="bg-white p-4 h-100 shadow-sm border-0">
                    <div class="card-body">
                        <div class="d-flex align-items-center">

                        <i class="fa-solid text-color fa-screwdriver-wrench fs-1 me-3"></i>

                        <h3 class="text-color  fs-5 fw-bold my-3">
                            Implementation & Tech Selection
                        </h3>
                        </div>
                        <p class="card-text text-secondary">
                            We ensure smooth deployment or migration with minimal disruptions. Our team helps select the most suitable technologies for seamless and successful business transformation.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Step 4 -->
            <div class="col-md-6">
                <div class="bg-white p-4 h-100 shadow-sm border-0">
                    <div class="card-body">
                        <div class="d-flex align-items-center">

                        <i class="fa-solid text-color fa-diagram-project fs-1  me-3"></i>
                        <h3 class="text-color fs-5 fw-bold my-3">
                            Product Development
                        </h3>
                        </div>
                        <p class="card-text text-secondary">
                            We adopt an agile approach, breaking the development process into sprints. Continuous monitoring and optimization ensure issue resolution, efficiency, and cost-effectiveness of your IT infrastructure.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Step 5 -->
            <div class="col-md-12">
                <div class="bg-white p-4 h-100 shadow-sm border-0">
                    <div class="card-body">
                        <div class="d-flex align-items-center">

                        <i class="fa-solid text-color fa-shield-halved fs-1 me-3"></i>
                        <h3 class="text-color my-3 fs-5 fw-bold">
                            Quality Assurance and Support
                        </h3>
                        </div>
                        <p class="card-text text-secondary">
                            Our experts ensure compliance with best coding practices, maintaining high-quality standards. We provide robust ongoing support and scalable solutions to help your infrastructure evolve with your business.
                        </p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>

<div class="container-fluid py-5" style="background: #F1F5FA">
    <div class="container pt-4">
        <h2 class=" fs-2 fw-bolder text-color text-center ">Benefits of Choosing Volmint’s Cloud and DevOps Consulting Services</h2>

        <div class="row mx-auto w-100 ">
            <div class="col-12 p-3 col-md-6 ">
                <div class=" shadow section_hero h-100 p-3">
                    <div class="d-flex g-3 align-items-center">

                    <div class="border shadow d-flex justify-content-center align-items-center rounded-circle"  style="width: 60px; height: 60px">
                        <i class="fa-solid fa-meteor fs-2 text-white"></i>
                    </div>
                    <h3 class="text-white mt-2 ms-3 fs-5 fw-bold">
                        Faster Time-to-Market                    </h3>
                     </div>
                    <p class="text-white mt-3 ms-2">
                        We are one of the fastest-growing application-focused, high-end managed service providers, ensuring streamlined development and deployment cycles.
                    </p>
                </div>
            </div>
            <div class="col-12 p-3 col-md-6">
                <div class="p-3 bg-white h-100">
                    <div class="d-flex g-3 align-items-center">
                        <div class="border-blue shadow d-flex justify-content-center align-items-center rounded-circle"  style="width: 60px; height: 60px">
                            <i class="fa-solid fa-money-bill-transfer fs-2 text-color"></i>
                        </div>
                        <h3 class="text-color ms-3 mt-2 fs-5 fw-bold">
                            Cost Efficiency
                        </h3>
                    </div>


                    <p class="text-muted mt-3 ms-2">
                        We provide the best IT infrastructure that optimizes your existing applications, crafts new ideas into concepts using numerous resources, and reduces operational costs.                </div>
            </div>
            <div class="col-12 p-3 col-md-6">
                <div class="p-3 bg-white h-100">
                    <div class="d-flex align-items-center">
                        <div class="border-blue shadow d-flex justify-content-center align-items-center rounded-circle"  style="width: 60px; height: 60px">
                            <i class="fa-solid fa-person-chalkboard fs-2 text-color"></i>                          </div>
                        <h3 class="text-color ms-3 mt-2 fs-5 fw-bold">
                            Training & Consultation
                        </h3>
                    </div>

                    <p class="text-muted mt-3 ms-2">
                        We empower your team to build in-house expertise to manage and scale your infrastructure with confidence and unlock the full potential of cloud services and DevOps.
                    </p>
                </div>
            </div>
            <div class="col-12 p-3 col-md-6">
                <div class="bg-white p-3 h-100">
                    <div class="d-flex align-items-center">
                        <div class="border-blue shadow d-flex justify-content-center align-items-center rounded-circle"  style="width: 60px; height: 60px">
                            <i class="fa-solid fa-fingerprint text-color fs-2"></i>
                        </div>
                        <h3 class="text-color mt-2 ms-3 fs-5 fw-bold">
                            Security and Backup
                        </h3>
                    </div>

                    <p class="text-muted mt-3 ms-2">
                        Benefit from robust, cloud-native security practices. We also offer automated recovery-backup and failback-failover mechanisms for data center and IT operations.
                    </p>
                </div>
            </div>
            <div class="col-12 p-3 col-md-6">
                <div class="bg-white p-3 h-100">
                    <div class="d-flex align-items-center">

                    <div class="border-blue shadow d-flex justify-content-center align-items-center rounded-circle"  style="width: 60px; height: 60px">
                        <i class="fa-solid fa-headset fs-2 text-color"></i>                    </div>
                    <h3 class="text-color ms-3 fs-5 fw-bold">
                        Expert Support
                    </h3>
                    </div>
                    <p class="text-muted mt-3 ms-2">
                        In addition to training, we provide personalized experienced professionals for reliable assistance that helps to improve communication between development and operations teams.                    </p>
                </div>
            </div>
        </div>

    </div>
</div>
<section class=" container-fluid section_hero">
    <div class="container mx-auto px-6">
        <h2 class="text-white fw-bold text-center mb-12">
            Technologies We Use
        </h2>
        <div class="row justify-content-center mt-2 g-4">
            <div class="col-md-1">
                <div class="bg-white h-100 d-flex align-items-center justify-content-center px-1">
                <img src="assets/img/landing-new/server-management/cloud-1.png" alt="">
                </div>

            </div>
            <div class="col-md-1">
                <div class="bg-white h-100 d-flex align-items-center justify-content-center px-1">
                <img src="assets/img/landing-new/server-management/cloud-2.png" alt="">
                </div>

            </div>
            <div class="col-md-1">
                <div class="bg-white h-100 d-flex align-items-center justify-content-center px-1">
                <img src="assets/img/landing-new/server-management/cloud-3.png" alt="">
                </div>

            </div>
            <div class="col-md-1">
                <div class="bg-white h-100 d-flex align-items-center justify-content-center px-1">
                <img src="assets/img/landing-new/server-management/cloud-4.png" alt="">
                </div>

            </div>
            <div class="col-md-1">
                <div class="bg-white h-100 d-flex align-items-center justify-content-center px-1">
                <img src="assets/img/landing-new/server-management/cloud-5.png" alt="">
                </div>

            </div>
            <div class="col-md-1">
                <div class="bg-white h-100 d-flex align-items-center justify-content-center px-1">
                <img src="assets/img/landing-new/server-management/cloud-6.png" alt="">
                </div>

            </div>
            <div class="col-md-1">
                <div class="bg-white h-100 d-flex align-items-center justify-content-center px-1">
                <img src="assets/img/landing-new/server-management/cloud-7.png" alt="">
                </div>
            </div>
        </div>
    </div>
</section>

<div class="container-fluid pt-5">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="col-12">
                    <img src="assets/img/landing-new/mobile-development/faq.png" alt="Image" class="img-fluid w-50"/>
                    <h2 class="fs-1 fw-bold text-color">Frequently Asked Questions</h2>
                    <p class="text-secondary">Have a question that is not answered? You can contact us at</p>
                    <p class="text-color fw-bold">Email: <a href="mailto:support@volmint.com"
                                                                          class="text-decoration-underline text-color">support@volmint.com</a>
                    </p>
                    <button type="submit"
                            class="section_hero border-0 color-white px-5 py-2 fs-6 mt-4 fw-bold hover-effect"
                            (click)="goTo('/faq')">
                        View All Faqs
                    </button>
                </div>
            </div>
            <div class="col-12 col-md-6 mt-4">
                <div class="accordion" id="faqAccordion">
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingOne">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                <span class="fs-6 fw-bold text-color w-100 ">
                                    <div class="row ">
                                        <div class="col-1  ">
                                          <div class="encircled-icon ">
                                                <i class="fas fa-question fw-bold"></i>
                                          </div>
                                        </div>
                                        <div class="col-11 ps-4 ps-md-3">
What is the benefit of combining Cloud and DevOps services?
                                        </div>
                                    </div>
                                </span>
                            </button>
                        </h3>
                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                The combination of cloud and DevOps services offers various benefits such as allowing businesses to achieve faster application delivery, greater flexibility, and optimized IT infrastructure while leveraging the scalability of the cloud.

                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingTwo">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        <span
                            class="fs-6 fw-bold text-color w-100">
                             <div class="row align-items-center">
                                        <div class="col-1">
                                            <div class="encircled-icon">
                                                <i class="fas fa-question fw-bold"></i>
                                            </div>
                                        </div>
                                 <div class="col-11 ps-4 ps-md-3">
                                    Can Volmint help with cloud migration?
                                 </div>
                             </div>
                            </span>
                            </button>
                        </h3>
                        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                Absolutely! We offer seamless cloud migration services, ensuring minimal downtime and data integrity throughout the process.

                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingThree">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                <span class="fs-6 fw-bold text-color w-100">
                                    <div class="row align-items-center">
                                        <div class="col-1">
                                            <div class="encircled-icon">
                                                <i class="fas fa-question fw-bold"></i>
                                            </div>
                                        </div>
                                        <div class="col-11 ps-4 ps-md-3">
Which cloud platforms does Volmint support?
                                        </div>
                                    </div>
                                </span>
                            </button>
                        </h3>
                        <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                Being the fastest-growing cloud managed services providers, we work with leading cloud platforms, including AWS, Azure, and Google Cloud, to provide tailored solutions.

                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingFour">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                <span class="fs-6 fw-bold text-color">
                                    <div class="row align-items-center">
                                        <div class="col-1">
                                            <div class="encircled-icon">
                                                <i class="fas fa-question fw-bold"></i>
                                            </div>
                                        </div>
                                        <div class="col-11 ps-4 ps-md-3">
How does DevOps improve development cycles?
                                        </div>
                                    </div>
                                </span>
                            </button>
                        </h3>
                        <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                By integrating automation and CI/CD pipelines, DevOps reduces bottlenecks, enhances collaboration, and accelerates the development-to-deployment process.

                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingFive">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                <span class="fs-6 fw-bold text-color" >
                                    <div class="row align-items-center">
                                        <div class="col-1">
                                            <div class="encircled-icon">
                                        <i class="fas fa-question fw-bold"></i>
                                            </div>
                                        </div>
                                        <div class="col-11 ps-4 ps-md-3">
Is Volmint’s support available post-deployment?
                                        </div>
                                    </div>
                                </span>
                            </button>
                        </h3>
                        <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                Yes, we offer ongoing support, optimization, and scalability options to ensure your systems stay efficient and secure.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid section_hero ps-5 mt-5">
    <div class="container">
        <div class="row align-items-center py-5">
            <div class="col-md-10 col-12">
                <h1 class="text-white">Ready to Take Your Business Growth to the Next Level?</h1>
            </div>
            <div class="col-md-2 col-12">
                <button class=" bg-white rounded-0 px-5 py-3 text-color fw-bold hover-effect"
                        (click)="goTo('/contact')">Contact Us
                </button>
            </div>
        </div>
    </div>
</div>
